import { useEffect } from 'react';

export default function CallModeDismissGuard(){
  useEffect(()=>{
    const close=()=>{
      const button=document.querySelector('.broker-call-overlay .close') as HTMLButtonElement|null;
      button?.click();
    };
    const onKey=(event:KeyboardEvent)=>{if(event.key==='Escape'&&document.querySelector('.broker-call-overlay'))close();};
    const onClick=(event:MouseEvent)=>{
      const target=event.target as HTMLElement|null;
      if(target?.classList.contains('broker-call-overlay'))close();
    };
    document.addEventListener('keydown',onKey);
    document.addEventListener('click',onClick);
    return()=>{document.removeEventListener('keydown',onKey);document.removeEventListener('click',onClick);};
  },[]);
  return null;
}
